const React = require('react');

const LegalPageLayout = require('layouts/LegalPageLayout');
const AccessibilityContents = require('components/AccessibilityContents');
const { default: Classes } = require('./styles.scss');

module.exports = class Accessibility extends React.PureComponent {

    render() {

        return (
            <LegalPageLayout>
                <AccessibilityContents className={Classes.legalContents} />
            </LegalPageLayout>
        );
    }
};
